import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import tab1 from '../assets/image/Use Cases_tb1.png'
import tab2 from '../assets/image/Use Cases_tb2.png'
import tab3 from '../assets/image/Use Cases_tb3.png'
import tab4 from '../assets/image/Use Cases_tb4.png'
import tab5 from '../assets/image/Use Cases_tb5.png'
import tab6 from '../assets/image/Use Cases_tb6.png'
import tab7 from '../assets/image/Use Cases_tb7.png'
import active_tab1 from '../assets/image/Use Cases_tb1_xt.png'
import active_tab2 from '../assets/image/Use Cases_tb2_xt.png'
import active_tab3 from '../assets/image/Use Cases_tb3_xt.png'
import active_tab4 from '../assets/image/Use Cases_tb4_xt.png'
import active_tab5 from '../assets/image/Use Cases_tb5_xt.png'
import active_tab6 from '../assets/image/Use Cases_tb6_xt.png'
import active_tab7 from '../assets/image/Use Cases_tb7_xt.png'

export default new Vuex.Store({
    state: {
     load_show:false,
     menuList:[    
      {id:1,title:'Products',path:'',child:[{id:10,title:'Card Payments',path:'card-payments'},{id:11,title:'Card Payouts',path:'card-payouts'},]},
      {id:16,title:'Use Cases',path:'',child:[
        {id:12,title:'Travel & Tourism',path:'travel-tourism',icons:{unActive:tab6,active:active_tab6}},{id:13,title:'E-Commerce',path:'e-commerce',icons:{unActive:tab1,active:active_tab1}},
        {id:14,title:'E-SaaS',path:'e-saas',icons:{unActive:tab4,active:active_tab4}},{id:15,title:'Retail',path:'retail',icons:{unActive:tab7,active:active_tab7}},
        {id:17,title:'Educational Platforms',path:'educational-platforms',icons:{unActive:tab5,active:active_tab5}},{id:18,title:'Online Gaming',path:'online-gaming',icons:{unActive:tab3,active:active_tab3}},
        {id:19,title:'Marketplaces',path:'marketplaces',icons:{unActive:tab2,active:active_tab2}},
      ]},
      // {id:3,title:'Games',path:'games'},
      {id:2,title:'About Us',path:'about-us'},
      // {id:4,title:'pages',path:'',child:[{id:5,title:'Privacy Policy',path:'privacy-policy',},{id:6,title:'Terms Of Use',path:'terms',}]},
      // {id:5,title:'Privacy Policy',path:'privacy-policy',},
      // {id:6,title:'Terms Of Use',path:'terms',},
      {id:9,title:'Contact Us',path:'contact-us',},
      // {id:7,title:'TERMS AND CONDITIONS',path:'terms'}
      // {id:8,title:'Join',path:'join',},
     
      ],
      joinList:[
   
      ],
      games:[
    
      ],
    },
  
    mutations: {
      setLoad (state, value) {
        state.load_show = value
      }, 
    },
   
})
